import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class VtLinkService {
    constructor(private dataTask: DataTaskService) {}

    public getSetting(params: VtLinkParams): Promise<VtLinkSetting[]> { return this.dataTask.Post(3793, params); }
    public listLinkTypes(): Promise<VtLinkType[]> { return this.dataTask.Post(3794); }
    public listWebPages(): Promise<Item[]> { return this.dataTask.Post(4); }
}

export interface VtLinkParams { vt_keyno: string; vtlink_keyno: string; }
export interface VtLinkSetting extends VtLinkParams {
    argtype: string; argvalue: string; p2_webpage_keyno: string; p2_subscription_keyno: string;
    p2_releasenote_keyno: string; p2_setting_keyno: string; [key: string]: string;
}
export interface VtLinkType { vtlinktype_id: string; vtlinktype_name: string; }
